(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-bottom-nav"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  const nav = document.getElementById('kk-mobile-nav');
  if (!nav) return;

  // ── Ripple on tap ─────────────────────────────────────────
  nav.addEventListener('click', function (e) {
    const item = e.target.closest('.kk-nav-item');
    if (!item) return;
    const wrap = item.querySelector('.kk-nav-icon-wrap');
    if (!wrap) return;
    const r = document.createElement('span');
    r.className = 'kk-ripple';
    wrap.appendChild(r);
    setTimeout(() => r.remove(), 450);
  });

  // ── Account item: trigger desktop account popup ───────────
  // nav.addEventListener('click', function (e) {
  //   const item = e.target.closest('.kk-nav-item[data-account-trigger]');
  //   if (!item) return;
  //   e.preventDefault();

  //   // Try every possible selector Shopify's Horizon theme uses for the account button
  //   const desktopBtn =
  //     document.querySelector('[data-customer-account-trigger]') ||
  //     document.querySelector('customer-account-trigger button') ||
  //     document.querySelector('customer-account-trigger') ||
  //     document.querySelector('#CustomerAccountDropdown button') ||
  //     document.querySelector('button[aria-controls*="account" i]') ||
  //     document.querySelector('header button[aria-haspopup="dialog"]') ||
  //     document.querySelector('button[data-customer-account]');

  //   if (desktopBtn) {
  //     desktopBtn.click();
  //   } else {
  //     // Fallback: go directly to Shopify new customer accounts login
  //     window.location.href = '/customer_authentication/login';
  //   }
  // });

  // ── Live cart badge via Shopify Cart API ──────────────────
  function updateCartBadges(count) {
    document.querySelectorAll('[data-cart-badge]').forEach(function (badge) {
      badge.textContent = count;
      badge.setAttribute('aria-label', count + ' items in cart');
      badge.classList.toggle('is-hidden', count === 0);
    });
  }

  fetch('/cart.js')
    .then(r => r.json())
    .then(data => updateCartBadges(data.item_count))
    .catch(() => {});

  document.addEventListener('cart:refresh', function () {
    fetch('/cart.js')
      .then(r => r.json())
      .then(data => updateCartBadges(data.item_count))
      .catch(() => {});
  });

  const _origFetch = window.fetch;
  window.fetch = function () {
    return _origFetch.apply(this, arguments).then(function (response) {
      const url = (arguments[0] || '').toString();
      if (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update') || url.includes('/cart/clear')) {
        setTimeout(function () {
          _origFetch('/cart.js')
            .then(r => r.json())
            .then(data => updateCartBadges(data.item_count))
            .catch(() => {});
        }, 300);
      }
      return response;
    });
  };

  // ── Active page highlight ─────────────────────────────────
  const currentPath = window.location.pathname;
  nav.querySelectorAll('.kk-nav-item').forEach(function (item) {
    const href = item.getAttribute('href');
    if (!href || href === '#') return;

    item.classList.remove('is-active');
    item.removeAttribute('aria-current');

    let hrefPath = href;
    try { hrefPath = new URL(href, window.location.origin).pathname; } catch(e) {}

    if (hrefPath === '/' && currentPath === '/') {
      item.classList.add('is-active');
      item.setAttribute('aria-current', 'page');
    } else if (hrefPath !== '/' && currentPath.startsWith(hrefPath)) {
      item.classList.add('is-active');
      item.setAttribute('aria-current', 'page');
    }
  });

})();

  } catch(e) { console.error(e); }
})();
})();
